import { HStack, SimpleGrid, Text, Image } from "@chakra-ui/react";
import React from "react";
import type { OrderProductData } from "@/store/types/order";
import { observer } from "mobx-react";

interface Props {
  product: OrderProductData;
  subtotalLabel: string;
}

export const OrderSummaryTableItem = observer(
  ({ product, subtotalLabel }: Props) => {
    return (
      <HStack
        spacing="14"
        flexDirection={{ base: "column", md: "row" }}
      >
        <Image
          src={product.language.imageSrc}
          width="284px"
          maxWidth="100%"
          height="244px"
          alt="box"
          borderRadius="6px"
          objectFit="cover"
        />

        <SimpleGrid
          columns={{ sm: 1, md: 2 }}
          flex="1"
          textAlign="center"
          spacing="4"
        >
          <HStack spacing="4">
            <Text>{product.language.numberOfLabel}</Text>
            <Text>{product.quantity}</Text>
          </HStack>

          <HStack
            spacing="4"
            justifyContent="flex-end"
          >
            <HStack alignSelf="flex-end">
              <Text>{subtotalLabel}</Text>
              <Text fontWeight="bold">{product.totalFormatted}</Text>
            </HStack>
          </HStack>
        </SimpleGrid>
      </HStack>
    );
  },
);
